import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass('JoyCircularProgress', slot);
}
const circularProgressClasses = generateUtilityClasses('JoyCircularProgress', ['root', 'determinate', 'svg', 'track', 'progress', 'colorPrimary', 'colorNeutral', 'colorDanger', 'colorInfo', 'colorSuccess', 'colorWarning', 'sizeSm', 'sizeMd', 'sizeLg', 'variantPlain', 'variantOutlined', 'variantSoft', 'variantSolid']);
export default circularProgressClasses;